import assets from './assets';
import transcodings from './transcodings';
import conversions from './conversions';
import lives from './lives';
import categories from './categories';
import clips from './clips';

export default [...assets, ...transcodings, ...conversions, ...lives, ...categories, ...clips];
